// extracted by mini-css-extract-plugin
export default {"logoutButton":"Logout_logoutButton__pAZqT"};